import { rootElement } from '@shared/setup';
import SignInModal from './SignIn/SignInModal.vue';

const initSignInModal = async () => {
    rootElement({
        name: 'SignInModalEntry', // pascal, camel & kebab-case are valid
        component: SignInModal,
        vm: {},
        contextComponents: [{ name: 'WaitForLoading', template: '<div>Waiting...</div><RouterView></RouterView>' }],
    });
};

initSignInModal();
